import React, { lazy, Suspense } from "react";
// import Loader from "./../components/loader.js";
import { ALL_CONSTANTS } from "../constants/displayConstants";
// import NLI_CONSTANTS from "../Products/nli/data/urlPathConstants.js";
import withLazyAndSuspense from "../utils/lazy.js";
import getServiceNameFromPath from "./mapping.js";
import { customLoadable } from "../utils/appUtils";
// import withLazyAndSuspense from '../../../utils/lazy';
import DORMANCY_URL_CONSTANTS from '../Products/DormancyRemoval/data/URLConstants';
import LoadingIndicator from "../Products/v2Components/LoadingIndicator.js";

const pathName = window.location.pathname;
const serviceName = getServiceNameFromPath(pathName);
const Options = withLazyAndSuspense(() =>
  import("@src/Products/userVerification/chooseOptions")
);
const HomePage = withLazyAndSuspense(() =>
  import("@src/Products/HomeScreen/HomeScreen")
);

const componentToRender = (pathName) => {
  if (
    pathName === ALL_CONSTANTS.DUE_PATH ||
    pathName === ALL_CONSTANTS.DUE_VERIFICATION_PATH
  ) {
    return Options;
  } else {
    return HomePage;
  }
};

const Tablescreen = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/TableScreen")
);

const RekycNochange = withLazyAndSuspense(() =>
  import("../Products/rekyc/UpdateRekyc/detailsAccordian.web.js")
);

const DiscrepantDocumentsHome = withLazyAndSuspense(() =>
  import("../Products/nli/uploadDiscrepantDocuments/discrepantDocumentHome")
);
const DiscrepantDocumentsAuthentication = withLazyAndSuspense(() =>
  import("../Products/nli/uploadDiscrepantDocuments/discrepantDocumentAuth")
);
const DiscrepantDocumentsSuccess = withLazyAndSuspense(() =>
  import("../Products/nli/uploadDiscrepantDocuments/discrepantDocumentSuccess")
);

const CreditCardPaymentError = withLazyAndSuspense(() =>
  import("../Products/nli/services/creditCardPayment/CreditCardPaymentError")
);

const Verification = withLazyAndSuspense(() =>
  import("../Products/Newhomescreen/Verification")
);

const DownTime = withLazyAndSuspense(() =>
  import('../Products/Errorpage/Downtime/downtimeScreen.js'),
);

const NewDueVerification = withLazyAndSuspense(() =>
  import("../Products/OverDue/newVerification.js")
);

const ValidateUrl = withLazyAndSuspense(() =>
  import("../Products/Newhomescreen/validateUrl.js")
);

const PanNumber = withLazyAndSuspense(() =>
  import("../Products/userVerification/panNumber")
);

const AdhaarNumber = withLazyAndSuspense(() =>
  import("../Products/userVerification/aadharNumber")
);

const DOB = withLazyAndSuspense(() =>
  import("../Products/userVerification/dob/index")
);

const OtpScreen = withLazyAndSuspense(() =>
  import("../Products/OtpScreen/OtpScreen")
);

const AadharOtpscreen = withLazyAndSuspense(() =>
  import("../Products/OtpScreen/aadharOtpscreen")
);
const DualAuth = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/dualAuth")
);
const MobileScreen = withLazyAndSuspense(() =>
  import("../Products/Mobilescreen/MobileScreen")
);
const Updatedscreen = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/Updatedscreen")
);
const Feedback = withLazyAndSuspense(() =>
  import("../Products/nli/services/feedbackNLI/feedback")
);
const FeedbackExp = withLazyAndSuspense(() =>
  import("../Products/nli/services/feedbackNLI/feedSelect")
);

const FeedbackRec = withLazyAndSuspense(() =>
  import("../Products/nli/services/feedbackNLI/feedbackRec")
);
const LoanTracker = withLazyAndSuspense(() =>
  import("../Products/nli/services/loanTracker/loanTracker.js")
);
const NLIError = withLazyAndSuspense(() =>
  import("../Products/nli/components/nliErrorPage")
);
const NLISuccess = withLazyAndSuspense(() =>
  import("../Products/nli/components/nliSuccessPage")
);
const NLIDuplicateSuccess = withLazyAndSuspense(() =>
  import("../Products/nli/components/nliDuplicateSuccessPage")
);

const Update = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/update")
);

const UpdateData = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/updateData")
);
const Details = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/details")
);

const ErrorPage = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/errorPage")
);

const sessionExipry = withLazyAndSuspense(() =>
  import("../Products/HomeScreen/sessionExpired")
);

const Transactionerrorpage = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/transactionError")
);

const TransactionSuccess = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/transactionSuccess")
);
const SettelmentPayStatus = withLazyAndSuspense(() =>
  import("../Products/OverDue/settlementPayStatus")
);
// Overdue Screens
const OverdueDetails = withLazyAndSuspense(() =>
  import("../Products/OverDue/OverdueDetails")
);

const NewOverdue = withLazyAndSuspense(() =>
  import("@src/Products/OverDue/newOverdueScreen")
);

//Overdue Payment Status
const OverduePayStatus = withLazyAndSuspense(() =>
  import("../Products/OverDue/overduePayStatus")
);
const DiyErrorPage = withLazyAndSuspense(() =>
  import("../Products/OverDue/diyErrorPage.js")
);
const AccountNo = withLazyAndSuspense(() =>
  import("../Products/AccountNo/AccountNo")
);

const layout = withLazyAndSuspense(() =>
  import("../Products/InternalComponents/layout")
);

const UpdatePan = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/updatePan")
);

const UpdateEmail = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/updateEmail")
);

const UpdateUsername = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/updateUsername")
);

const errorpage = withLazyAndSuspense(() =>
  import("../Products/Errorpage/errorpage")
);

const NotFound404 = withLazyAndSuspense(() =>
  import('../Products/OverDue/NotFound404'),
);

const OverDueScreen = withLazyAndSuspense(() =>
  import("../Products/OverDue/OverDueScreen")
);
const PayAmount = withLazyAndSuspense(() => import("../Products/OverDue/payAmount"));

const iAgreePage = withLazyAndSuspense(() =>
  import("../Products/termsNcondition/termsNcondition")
);
const ConfirmManager = withLazyAndSuspense(() =>
  import("../Products/userVerification/confirmManager")
);
const ConfirmCustomer = withLazyAndSuspense(() =>
  import("../Products/userVerification/confirmCustomer")
);
const verifyUser = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/verifyUser")
);
//rekyc
const rekyc = withLazyAndSuspense(() => import("../Products/rekyc/rekyc"));
const rekycSuccess = withLazyAndSuspense(() =>
  import("../Products/rekyc/rekycSuccess")
);

const RekycErrorRedirect = withLazyAndSuspense(() =>
  import("../Products/rekyc/error.web")
);

const rekycHome = withLazyAndSuspense(() => import("../Products/rekyc/main.web"));
const rekycData = withLazyAndSuspense(() => import("../Products/rekyc/data.web"));

//data quality
const dataQuality = withLazyAndSuspense(() =>
  import("../Products/dataQuality/dataQuality")
);
const dataQualitySuccess = withLazyAndSuspense(() =>
  import("../Products/dataQuality/dataQualitySuccess")
);

const CancelautodebitTable = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/Cancelautodebitmandate/CancelautodebitTable")
);

const DataQualityErrorRedirect = withLazyAndSuspense(() =>
  import("../Products/dataQuality/error.web")
);

const dataQualityHome = withLazyAndSuspense(() =>
  import("../Products/dataQuality/main.web")
);

const dataQualityData = withLazyAndSuspense(() =>
  import("../Products/dataQuality/data.web")
);

const dataQualityRemovedVflowSuccess = withLazyAndSuspense(() =>
  import("../Products/dataQuality/components/Success.web")
);

//Dual residency
const dualResidency = withLazyAndSuspense(() =>
  import("../Products/DualResidency/dualRes")
);

const dualResidencyHome = withLazyAndSuspense(() =>
  import("../Products/DualResidency/main.web")
);

const DualresidencyErrorRedirect = withLazyAndSuspense(() =>
  import("../Products/DualResidency/components/error.web")
);

// Data govenance
const dataGovernance = withLazyAndSuspense(() =>
  import("../Products/DataGovernance/dgov")
);

const dataGovernanceHome = withLazyAndSuspense(() =>
  import("../Products/DataGovernance/main.web")
);

const DatagovernanceErrorRedirect = withLazyAndSuspense(() =>
  import("../Products/DataGovernance/components/error.web")
);

const DatagovernanceSuccessRedirect = withLazyAndSuspense(() =>
  import("../Products/DataGovernance/components/success.web")
);

const demog = withLazyAndSuspense(() =>
  import("../Products/pebble/services/DemographicUpdation/index")
);

const pqOffer = withLazyAndSuspense(() =>
  import("../Products/OverDue/PqOffer/pqOffer.web")
);

const PebbleErrorScreen = withLazyAndSuspense(() =>
  import("../Products/pebble/pebbleErrorScreen")
);

const payslip = withLazyAndSuspense(() =>
  import("../Products/pebble/services/Payslip/payslip")
);

const Variant = withLazyAndSuspense(() =>
  import("../Products/pebble/services/VariantMigration/index")
);

const Solvency = withLazyAndSuspense(() =>
  import("../Products/pebble/services/SolvencyCertificate/index")
);

const BankingKyc = withLazyAndSuspense(() =>
  import("../Products/pebble/services/BankingCertificate/index")
);

const EmailMobileModification = withLazyAndSuspense(() =>
  import("../Products/pebble/services/EmailMobileModification/index")
);

const Pebble = withLazyAndSuspense(() => import("../Products/pebble/pebble"));

const gridAuthentication = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/gridAutentication/gridAuthentication")
);

const Gridautherrorscreen = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/gridAutentication/Gridautherrorscreen")
);

const gridAuthsuccessScreen = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/gridAutentication/gridAuthsuccessScreen")
);

const PebbleStatusRedirect = withLazyAndSuspense(() =>
  import("../Products/rekyc/error.web")
);

const PebbleErrorRedirect = withLazyAndSuspense(() =>
  import("../Products/DataGovernance/components/error.web")
);

const agentLogin = withLazyAndSuspense(() =>
  import("../Products/Updatedscreen/agentLogin")
);


const TermsAndConditionsWhatsApp = withLazyAndSuspense(() =>
  import("../Products/termsNcondition/termsandcondition")
);

const VehicleValuation = withLazyAndSuspense(() =>
  import("../Products/carDekho/vehicleValuation")
);

const VehicleDetails = withLazyAndSuspense(() =>
  import("../Products/carDekho/vehicleDetails")
);

const Cardekholastscreen = withLazyAndSuspense(() =>
  import("../Products/Newhomescreen/Cardekholastscreen")
);

const CarDetails = withLazyAndSuspense(() =>
  import("../Products/carDekho/carDetails")
);

const redirectHome = withLazyAndSuspense(() =>
  import("../Products/userVerification/redirectHome")
);

// NLI
const ServiceRequest = withLazyAndSuspense(() =>
  import("../Products/nli/services/ServiceRequest/renderServiceRequest")
);

const ForexSubmit = withLazyAndSuspense(() =>
  import("../Products/nli/services/ForexInsta/renderSubmitForex")
);

const PropertySearch = withLazyAndSuspense(() =>
  import("../Products/nli/services/PropertySearch/renderPropertySearch")
);

const GDPRdisclaimer = withLazyAndSuspense(() =>
  import("../Products/nli/services/GDPR/renderDis")
);

const GDPR = withLazyAndSuspense(() =>
  import("../Products/nli/services/GDPR/renderGdpr")
);

const CustomerCheck = withLazyAndSuspense(() =>
  import("../Products/nli/services/GDPR/renderCustomer")
);

const ForexInsta = withLazyAndSuspense(() =>
  import("../Products/nli/services/ForexInsta/renderForexInsta")
);

const ConfirmSR = withLazyAndSuspense(() =>
  import("../Products/nli/services/ServiceRequest/renderConfirmSR")
);

// const LazyLoadedQrLogin = lazy(() =>
//   import("../Products/nli/services/QRCode/renderQrLogin")
// );

// const QrLogin = (props) => {
//   return (
//     <Suspense fallback={<Loader loading={true} />}>
//       <LazyLoadedQrLogin {...props} />
//     </Suspense>
//   );
// };

const LoanQrLogin = withLazyAndSuspense(() =>
  import("../Products/nli/services/LoanQRCode/loanQRCodeLogin")
);

const GridCardLogin = withLazyAndSuspense(() =>
  import("../Products/nli/services/gridCardAuthentication/gridCardLogin")
);

const GridCardAuthentication = withLazyAndSuspense(() =>
  import("../Products/nli/services/gridCardAuthentication/gridAuthentication.js")
);

const MultiwalletLogin = withLazyAndSuspense(() =>
  import("../Products/nli/services/MultiwalletCard/multiWalletLogin.js")
);

const MultiwalletDash = withLazyAndSuspense(() =>
  import("../Products/nli/services/MultiwalletCard/multiWalletDash.web")
);

const SettlementScreen = withLazyAndSuspense(() =>
  import("../Products/OverDue/settlementScreen")
);

// kyc button
const kycButton = withLazyAndSuspense(() =>
  import("../Products/kycButton/kycButton")
);

const kycButtonRemovedVflowSuccess = withLazyAndSuspense(() =>
  import("../Products/kycButton/components/Success.web")
);

const kycButtonSuccess = withLazyAndSuspense(() =>
  import("../Products/kycButton/kycButtonSuccess")
);

const kycButtonErrorRedirect = withLazyAndSuspense(() =>
  import("../Products/kycButton/error.web")
);

const kycButtonHome = withLazyAndSuspense(() =>
  import("../Products/kycButton/main.web")
);

const kycButtonData = withLazyAndSuspense(() =>
  import("../Products/kycButton/data.web")
);

//kyc Button end
// * ForexCurrencyDelivery
const ForeignCurrencyDelivery = withLazyAndSuspense(() =>
  import("../Products/nli/ForeignCurrencyDelivery/ForeignCurrencyDelivery")
);

// Digilocker
const Digilocker = withLazyAndSuspense(() =>
  import('../Products/Digilocker/digilocker.js')
);
const DigilockerConsent = withLazyAndSuspense(() =>
  import('../Products/Digilocker/digilockerConsent.js')
);


//Quick Pay DIY

const QuickPay = withLazyAndSuspense(() =>
  import("../Products/OverDue/QuickPay/accountVerification.js")
);

const QuickPayStatus = withLazyAndSuspense(() =>
  import("../Products/OverDue/QuickPay/quickPayStatus.js")
);

const QuickpayErrorPage = withLazyAndSuspense(() =>
  import("../Products/OverDue/QuickPay/QuickpayErrorPage.js")
);

const Vkyc = withLazyAndSuspense(() =>
  import('../Products/MinorToMajor/screens/VKYC.js'),
);

const m2mError = withLazyAndSuspense(() =>
  import('../Products/MinorToMajor/screens/ErrorPage.js'),
);

const MinorToMajor = withLazyAndSuspense(() =>
  import('../Products/MinorToMajor/MinorToMajor.js'),
);

const RekycNoChangeSuccess = withLazyAndSuspense(() =>
  import('../Products/rekyc/UpdateRekyc/noChangeSuccess.js'),
);
const dormancyRemoval = withLazyAndSuspense(() => import('../Products/DormancyRemoval/rekyc'));

const dormancySuccess = withLazyAndSuspense(() => import('../Products/DormancyRemoval/rekycSuccess'));

const dormancyError = withLazyAndSuspense(() => import('../Products/DormancyRemoval/error.web'));

const dormacyRemovalHome = withLazyAndSuspense(() => import('../Products/DormancyRemoval/main.web'));

const dormancyRemovalData = withLazyAndSuspense(() => import('../Products/DormancyRemoval/data.web'));

const ForeignCurrencyDeliverySSO = withLazyAndSuspense(() =>
  import('../Products/nli/ForeignCurrencyDelivery/VerifyCustomer.js'),
);

const CommonRouteMap = {
   NotFound404: {
    component: NotFound404,
    path: '/servicing/due/notFound',
  },
    dormancyRemoval: {
    component: dormancyRemoval,
    path: DORMANCY_URL_CONSTANTS.DORMANCY_REMOVAL,
  },
  dormancySuccess: {
    component: dormancySuccess,
    path: DORMANCY_URL_CONSTANTS.DORMANCY_REMOVAL_SUCCESS,
  },
  dormacyRemovalHome: {
    component: dormacyRemovalHome,
    path: DORMANCY_URL_CONSTANTS.DORMANCY_REMOVAL_HOME,
  },
  dormancyRemovalData: {
    component: dormancyRemovalData,
    path: DORMANCY_URL_CONSTANTS.DORMANCY_REMOVAL_DATA,
  },
  dormancyError: {
    component: dormancyError,
    path: DORMANCY_URL_CONSTANTS.DORMANCY_REMOVAL_ERROR_REDIRECT,
  },
  ForeignCurrencyDeliverySSO: {
    component: ForeignCurrencyDeliverySSO,
    path: `/servicing/nli/VerifyCustomer`,
  },
  RekycNochange: {
    component: RekycNochange,
    path: '/servicing/rekyc-nochange',
  },
  RekycNoChangeSuccess: {
    component: RekycNoChangeSuccess,
    path: '/servicing/rekyc-success',
  },
  // * minor to major
  MinorToMajor: {
    component: MinorToMajor,
    path: `/servicing/minor-to-major`,
  },
  m2mError: {
    component: m2mError,
    path: `/servicing/m2mError`,
  },
  Vkyc: {
    component: Vkyc,
    path: '/servicing/m2mVkyc',
  },

  // * ForexCurrencyDelivery
  ForeignCurrencyDelivery: {
    component: ForeignCurrencyDelivery,
    path: `/servicing/nli/foreignCurrencyDelivery`,
  },
  // digilocker
  Digilocker: {
    component: Digilocker,
    path: '/servicing/digilockerRedirect',
  },
  DigilockerConsent: {
    component: DigilockerConsent,
    path: '/servicing/digilockerConsent',
  },
  //kyc button
  kycButtonRemovedVflowSuccess: {
    component: kycButtonRemovedVflowSuccess,
    path: `/servicing/kycButtonSuccess`,
  },
  kycButton: {
    component: kycButton,
    path: `/servicing/kycb`,
  },
  kycButtonSuccess: {
    component: kycButtonSuccess,
    path: `/servicing/kycButtonRedirect`,
  },
  kycButtonHome: {
    component: kycButtonHome,
    path: `/servicing/kycButtonProcess`,
  },
  kycButtonData: {
    component: kycButtonData,
    path: `/servicing/kycButtonData`,
  },

  kycButtonErrorRedirect: {
    component: kycButtonErrorRedirect,
    path: `/servicing/kycButtonError`,
  },

  //kyc button end

  Tablescreen: {
    component: Tablescreen,
    path: `/servicing${serviceName}/tablescreen`,
  },
  CancelautodebitTable: {
    component: CancelautodebitTable,
    path: `/servicing${serviceName}/CancelautodebitTable`,
  },
  // DueVerification: {
  //   component: DueVerification,
  //   path: `/servicing${serviceName}/DueVerification`,
  // },
  Verification: {
    component:
      serviceName === ALL_CONSTANTS.DUE_URL_END
        ? NewDueVerification
        // ? NotFound404
        : Verification,
    path: `/servicing${serviceName}/Verification `,
  },
  //  Overdue Verification
  // NewDueVerification: {
  //   component: NewDueVerification,
  //   path: `/servicing${serviceName}/DueVerification`,
  // },
  ValidateUrl: {
    component: ValidateUrl,
    path: `/servicing/ValidateUrl`,
  },
  UpdateUsername: {
    component: UpdateUsername,
    path: `/servicing${serviceName}/updateUsername`,
  },
  UpdateEmail: {
    component: UpdateEmail,
    path: `/servicing${serviceName}/updateEmail`,
  },
  UpdatePan: {
    component: UpdatePan,
    path: `/servicing${serviceName}/updatePan`,
  },
  AccountNo: {
    component: AccountNo,
    path: `/servicing${serviceName}/accountno`,
  },
  Updatedscreen: {
    component: Updatedscreen,
    path: `/servicing${serviceName}/updated`,
  },
  Update: {
    component: Update,
    path: `/servicing${serviceName}/update`,
  },
  UpdateData: {
    component: UpdateData,
    path: `/servicing${serviceName}/preview`,
  },
  ErrorPage: {
    component: ErrorPage,
    path: `/servicing${serviceName}/error`,
  },
  DownTime: {
    component: DownTime,
    path: `/servicing/underMaintenance`,
  },
  DiyErrorPage: {
    component: DiyErrorPage,
    path: `/servicing${serviceName}/diyError`,
  },

  sessionExipry: {
    component: sessionExipry,
    path: `/servicing${serviceName}/sessionExpired`,
  },
  MobileScreen: {
    component: MobileScreen,
    path: `/servicing${serviceName}/mobileno`,
  },
  OtpScreen: {
    component: OtpScreen,
    path: `/servicing${serviceName}/otp`,
  },
  AadharOtpscreen: {
    component: AadharOtpscreen,
    path: `/servicing${serviceName}/aadharOtp`,
  },
  DOB: {
    component: DOB,
    path: `/servicing${serviceName}/dob`,
  },
  errorpage: {
    component: errorpage,
    path: `/servicing${serviceName}/error`,
  },
  Transactionerrorpage: {
    component: Transactionerrorpage,
    path: `/servicing${serviceName}/transactionError`,
  },
  TransactionSuccess: {
    component: TransactionSuccess,
    path: `/servicing${serviceName}/transactionSuccess`,
  },
  AdhaarNumber: {
    component: AdhaarNumber,
    path: `/servicing${serviceName}/aadhaarno`,
  },
  PanNumber: {
    component: PanNumber,
    path: `/servicing${serviceName}/panno`,
  },
  Options: {
    component: Options,
    path: `/servicing${serviceName}/verify`,
  },
  OverDueScreen: {
    component: OverDueScreen,
    // component: NotFound404,
    path: `/servicing${serviceName}/overdue`,
  },

  //Overdue Screen
  NewOverdue: {
    component: NewOverdue,
    // component: NotFound404,
    path: `/servicing${serviceName}/overdueScreen`,
  },
  OverdueDetails: {
    component: OverdueDetails,
    // component: NotFound404,
    path: `/servicing${serviceName}/OverdueDetails`,
  },
  OverduePayment: {
    component: NewOverdue,
    // component: NotFound404,
    path: `/servicing${serviceName}/OverduePayment`,
  },

  OverduePayStatus: {
    component: OverduePayStatus,
    // component: NotFound404,
    path: `/servicing${serviceName}/overduePayStatus`,
  },
  //****** */

  // Quick Pay
  QuickPay: {
    component: QuickPay,
    // component: NotFound404,
    path: `/servicing${serviceName}/quickPay`,
  },

  QuickPayStatus: {
    component: QuickPayStatus,
    // component: NotFound404,
    path: `/servicing${serviceName}/QuickPayStatus`,
  },

  QuickpayErrorPage: {
    component: QuickpayErrorPage,
    // component: NotFound404,
    path: `/servicing${serviceName}/QuickpayErrorPage`,
  },
  //**** */

  ConfirmManager: {
    component: ConfirmManager,
    path: `/servicing${serviceName}/confirmManager`,
  },
  ConfirmCustomer: {
    component: ConfirmCustomer,
    path: `/servicing${serviceName}/confirmCustomer`,
  },
  redirectHome: {
    component: redirectHome,
    path: `/servicing${serviceName}/redirectHome`,
  },
  PayAmount: {
    component: PayAmount,
    path: `/servicing${serviceName}/payAmount`,
  },
  TermsAndConditionsWhatsApp: {
    component: TermsAndConditionsWhatsApp,
    path: `/servicing${serviceName}/termsandcondition`,
  },

  //* Discrepant module
  DiscrepantDocumentsHome: {
    component: DiscrepantDocumentsHome,
    path: "/servicing/nli/uploadDiscrepantDocumentsHome",
  },
  DiscrepantDocumentsAuthentication: {
    component: DiscrepantDocumentsAuthentication,
    path: "/servicing/nli/uploadDiscrepantDocumentsAuthentication",
  },
  DiscrepantDocumentsSuccess: {
    component: DiscrepantDocumentsSuccess,
    path: "/servicing/nli/uploadDiscrepantDocumentSuccess",
  },

  VehicleValuation: {
    component: VehicleValuation,
    path: `/servicing${serviceName}/vehicleValuation`,
  },
  VehicleDetails: {
    component: VehicleDetails,
    path: `/servicing${serviceName}/vehicleDetails`,
  },
  pqOffer: {
    component: pqOffer,
    path: `/pqOffer`,
  },

  SettlementScreen: {
    component: SettlementScreen,
    path: `/settlementScreen`,
  },
  preClosure: {
    component: SettlementScreen,
    path: "/preClosure",
  },
  Cardekholastscreen: {
    component: Cardekholastscreen,
    path: `/servicing${serviceName}/cardekholeaddetails`,
  },
  CarDetails: {
    component: CarDetails,
    path: `/servicing${serviceName}/carDetails`,
  },
  DualAuth: {
    component: DualAuth,
    path: `/servicing${serviceName}/dualAuth`,
  },
  iAgreePage: {
    component: iAgreePage,
    path: `/servicing${serviceName}/termsConditions`,
  },
  verifyUser: {
    component: verifyUser,
    path: `/servicing${serviceName}/verifyUser`,
  },
  //GridAuthentication
  gridAuthentication: {
    component: gridAuthentication,
    path: `/servicing/gridAuthentication`,
  },
  gridauthErrorScreen: {
    component: Gridautherrorscreen,
    path: `/servicing/GridauthErrorScreen`,
  },
  gridAuthsuccessScreen: {
    component: gridAuthsuccessScreen,
    path: `/servicing/gridAuthSuccessScreen`,
  },
  //data quality
  dataQuality: {
    component: dataQuality,
    path: `/servicing/data-ovd`,
  },
  dataQualitySuccess: {
    component: dataQualitySuccess,
    path: `/servicing/dataQualityRedirect`,
  },
  dataQualityHome: {
    component: dataQualityHome,
    path: `/servicing/dataQualityProcess`,
  },
  dataQualityData: {
    component: dataQualityData,
    path: `/servicing/dataQualityData`,
  },

  DataQualityErrorRedirect: {
    component: DataQualityErrorRedirect,
    path: `/servicing/dataQualityError`,
  },
  dataQualityRemovedVflowSuccess: {
    component: dataQualityRemovedVflowSuccess,
    path: `/servicing/dataQualitySuccess`,
  },

  rekyc: {
    component: rekyc,
    path: `/servicing/rekyc`,
  },
  rekycSuccess: {
    component: rekycSuccess,
    path: `/servicing/rekycRedirect`,
  },
  rekycHome: {
    component: rekycHome,
    path: `/servicing/rekycProcess`,
  },
  rekycData: {
    component: rekycData,
    path: `/servicing/rekycData`,
  },
  // Data governace
  dataGovernance: {
    component: dataGovernance,
    path: `/servicing/data-governance`,
  },
  dataGovernanceHome: {
    component: dataGovernanceHome,
    path: `/servicing/data-governance-process`,
  },
  DatagovernanceErrorRedirect: {
    component: DatagovernanceErrorRedirect,
    path: `/servicing/DatagovernanceError`,
  },
  DatagovernanceSuccessRedirect: {
    component: DatagovernanceSuccessRedirect,
    path: `/servicing/DatagovernanceSuccess`,
  },
  // Data governace end

  //Dual residency
  dualResidency: {
    component: dualResidency,
    path: `/servicing/dual-Residency`,
  },
  dualResidencyHome: {
    component: dualResidencyHome,
    path: `/servicing/dual-residency-process`,
  },
  DualresidencyErrorRedirect: {
    component: DualresidencyErrorRedirect,
    path: `/servicing/DualresidencyError`,
  },
  //Dual residency end

  // Pebble
  Variant: {
    component: Variant,
    path: `/pebbledemo`,
  },
  pebble: {
    component: Pebble,
    path: `/servicing/pebble`,
  },
  variantMigration: {
    component: Variant,
    path: `/servicing/pebble-services/variant-migration`,
  },
  solvencyCertificate: {
    component: Solvency,
    path: `/servicing/pebble-services/solvency-certificate`,
  },
  bankingKyc: {
    component: BankingKyc,
    path: `/servicing/pebble-services/banking-kyc`,
  },
  email: {
    component: EmailMobileModification,
    path: `/servicing/pebble-services/email-mobile-modification`,
  },
  payslip: {
    component: payslip,
    path: `/servicing/pebble-services/payslip`,
  },
  demog: {
    component: demog,
    path: `/servicing/pebble-services/demogUpdate`,
  },
  PebbleErrorScreen: {
    component: PebbleErrorScreen,
    path: `/servicing/pebbleError`,
  },
  bankingKyc: {
    component: BankingKyc,
    path: `/servicing/pebble-services/banking-kyc`,
  },
  email: {
    component: EmailMobileModification,
    path: `/servicing/pebble-services/email-mobile-modification`,
  },
  payslip: {
    component: payslip,
    path: `/servicing/pebble-services/payslip`,
  },
  demog: {
    component: demog,
    path: `/servicing/pebble-services/demogUpdate`,
  },
  PebbleStatusRedirect: {
    component: PebbleStatusRedirect,
    path: `/servicing/pebble-logout`,
  },
  PebbleErrorRedirect: {
    component: PebbleErrorRedirect,
    path: `/servicing/PebbleError`,
  },

  FeedbackRec: {
    component: FeedbackRec,
    path: `/servicing${serviceName}/feedback`,
  },
  FeedbackExp: {
    component: FeedbackExp,
    path: `/servicing${serviceName}/feedbackNPSForm`,
  },
  LoanTracker: {
    component: LoanTracker,
    path: `/servicing${serviceName}/loanTracker`,
  },
  Details: {
    component: Details,
    path: `/servicing${serviceName}/details`,
  },
  Feedback: {
    component: Feedback,
    path: `/servicing${serviceName}/feedbackExperience`,
  },
  NLIError: {
    component: NLIError,
    path: `/servicing${serviceName}/nliError`,
  },
  NLISuccess: {
    component: NLISuccess,
    path: `/servicing${serviceName}/nliSuccess`,
  },
  NLIDuplicateSuccess: {
    component: NLIDuplicateSuccess,
    path: `/servicing${serviceName}/nli-success`,
  },
  PropertySearch: {
    component: PropertySearch,
    path: `/servicing${serviceName}/propertySearch`,
  },
  ServiceRequest: {
    component: ServiceRequest,
    path: `/servicing${serviceName}/srRequestForm`,
  },
  GDPRdisclaimer: {
    component: GDPRdisclaimer,
    path: `/servicing/imobileservice/loadNliGdpr`,
  },
  CustomerCheck: {
    component: CustomerCheck,
    path: `/servicing/imobileservice/checkCustomer`,
  },
  GDPR: {
    component: GDPR,
    path: `/servicing/imobileservice/gdpr`,
  },
  ForexInsta: {
    component: ForexInsta,
    path: `/servicing${serviceName}/forexInstaBanking`,
  },
  ForexSubmit: {
    component: ForexSubmit,
    path: `/servicing${serviceName}/detailsResponse`,
  },
  ConfirmSR: {
    component: ConfirmSR,
    path: `/servicing${serviceName}/SRconfirmation`,
  },
  CreditCardPaymentError: {
    component: CreditCardPaymentError,
    path: `/servicing${serviceName}/makepayment/creditCard`,
  },
  LoanQrLogin: {
    component: LoanQrLogin,
    path: `/servicing${serviceName}/makepayment/loans`,
  },
  GridCardLogin: {
    component: GridCardLogin,
    path: `/servicing${serviceName}/gridCardLogin`,
  },
  GridCardAuthentication: {
    component: GridCardAuthentication,
    path: `/servicing${serviceName}/gridCardAuthentication`,
  },
  MultiwalletLogin: {
    component: MultiwalletLogin,
    path: `/servicing${serviceName}/prepaid`,
  },
  MultiwalletDash: {
    component: MultiwalletDash,
    path: `/servicing${serviceName}/prepaidDash`,
  },
  RekycErrorRedirect: {
    component: RekycErrorRedirect,
    path: `/servicing/rekycError`,
  },
  agentLogin: {
    component: agentLogin,
    path: `/servicing${serviceName}/agent-login`,
  },
  PanNumber: {
    component: PanNumber,
    path: `/servicing${serviceName}/panno`,
  },
  HomePage: {
    component: componentToRender(pathName),
    path: `/`,
  },
};

export default CommonRouteMap;
